import { MissingCardPaymentQueryService } from "../../../services/payments/MissingCardPaymentQueryService";
import { MissingCardPaymentModel } from "../../models/MissingCardPayment";
import { IQueryMissingCardPaymentRepository } from "../../ports/payments/IQueryMissingCardPaymentRepository";
import Query from "../Query";

class MissingCardPaymentQuery
  extends Query<MissingCardPaymentModel>
  implements IQueryMissingCardPaymentRepository
{
  constructor(public queryService: MissingCardPaymentQueryService) {
    super(queryService);
  }
}

export default MissingCardPaymentQuery;
